export const API_ENDPOINTS = {
    GET:"v1/company",
    POST:"v1/company",
    PUT:"v1/company",
    DELETE:(id:number)=>`v1/company/${id}`
}